import { ReactPortal } from '@/components/widgets/react-portal';

interface MeModalProps {
	isOpen: boolean;
	children: React.ReactNode;
};

export const MeModal = ({
	isOpen,
	children,
}: MeModalProps) => {
	return isOpen ? (
		<ReactPortal wrapperId="me-portal">
			{children}
		</ReactPortal>
	): null;
};
